import 'core-js/stable'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router/router.js'
import store from '@/store'
import http from '@/modules/http.js'
import onServerReject from '@/modules/on-server-reject.js'
import VueSocketIO from 'vue-socket.io'
import Vuelidate from 'vuelidate'
import i18n from './i18n'
import VueWorker from 'vue-worker'
import Notifications from 'vue-notification'

import '@/styles/style.less'

Vue.use(Vuelidate)
//Vue.use(VueI18n)

Vue.config.productionTip = false

http.interceptors.response.use(null, onServerReject)

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: http.defaults.baseURL.replace('/api/', '')
  })
)

import moment from 'moment/src/moment'
require('moment/locale/ru')
moment.locale('ru')

import VueYandexMetrika from 'vue-yandex-metrika'
Vue.use(VueYandexMetrika, {
  id: 68486605,
  router: router,
  env: process.env.NODE_ENV,
  options: {
    defer: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
  }
})

Vue.prototype.moment = moment

Vue.use(VueWorker)

Vue.use(Notifications)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
